<article class="form-wrapper">
  <header class="form-header">{{"NEW_SIGNUP" | translate}}</header>
  <form class="new-client-form" [formGroup]="signupForm" (ngSubmit)="onSubmit()">
    <label for="phone-number">{{'PHONE_NUMBER' | translate}}</label>
    <ngx-intl-tel-input
      id="phone-number"
      class="phone-number"
      formControlName="username"
      [preferredCountries]="[CountryISO.Netherlands, CountryISO.Germany]"
      [separateDialCode]="true"></ngx-intl-tel-input>
    <p *ngIf="signupForm.get('username')!.invalid && invalidSubmission === true" class="warning">
      {{'ENTER_VALID_MOBILE_PHONE_NUMBER' | translate}}
    </p>
    <ul class="warning-list" *ngIf="usernameErrorMessages.length !== 0">
      <li *ngFor="let m of usernameErrorMessages" class="warning-item">{{ m }}</li>
    </ul>

    <div class="name-wrapper">
      <div class="first-name-wrapper">
        <label for="first-name">{{ 'FIRST_NAME' | translate }}</label>
        <input id="first-name" type="text" class="first-name" formControlName="firstName" [placeholder]="'FIRST_NAME' | translate" />
        <p *ngIf="signupForm.get('firstName')!.invalid && invalidSubmission === true" class="warning">
          {{'ENTER_A_FIRST_NAME' | translate}}
        </p>
        <ul class="warning-list" *ngIf="firstNameErrorMessages.length !== 0">
          <li *ngFor="let m of firstNameErrorMessages" class="warning-item">{{ m }}</li>
        </ul>
      </div>
      <div class="last-name-wrapper">
        <label for="last-name">{{ 'LAST_NAME' | translate }}</label>
        <input id="last-name" type="text" class="last-name" formControlName="lastName" [placeholder]="'LAST_NAME' | translate" />
        <p *ngIf="signupForm.get('lastName')!.invalid && invalidSubmission === true" class="warning">
          {{'ENTER_A_LAST_NAME' | translate}}
        </p>
        <ul class="warning-list" *ngIf="lastNameErrorMessages.length !== 0">
          <li *ngFor="let m of lastNameErrorMessages" class="warning-item">{{ m }}</li>
        </ul>
      </div>
    </div>

    <label for="language">{{ 'LANGUAGE' | translate }}</label>
    <select id="language" formControlName="language">
      <option [ngValue]="null" disabled>{{ 'SELECT_A_LANGUAGE' | translate }}</option>
      <option [ngValue]="language" *ngFor="let language of languages; first as firstElement">{{ language | translate}}</option>
    </select>

    <label for="skip-movement_assignments">{{'MOVEMENT_ASSIGNMENTS' | translate}}</label>
    <select id="skip-movement_assignments" formControlName="movementsEnabled">
      <option [ngValue]="true">{{ 'YES' | translate }}</option>
      <option [ngValue]="false">{{ 'NO' | translate }}</option>
    </select>

    <button class="submit">{{'SIGNUP' | translate}}</button>
  </form>
  <footer>
    {{"FOOTER_SIGNUP_DESCRIPTION" | translate}}
  </footer>
</article>
